import React from 'react';
import { Button } from '@fluentui/react-components';
import { Table24Regular } from '@fluentui/react-icons';
import { useSelector } from 'react-redux';
import { AppState } from '../../redux/reducers';
import { ExportConsumptionByPractitionerWrapper } from './Wrappers/ExportConsumptionByPractitionerWrapper';
import { IConsumptionsFilters } from '../../models/Filters/ConsumptionsFilters';
import { ExportProtocolConsumptionWrapper } from './Wrappers/ExportProtocolConsuptionWrapper';

const handleDownload = async (authToken : string, filters : IConsumptionsFilters, entityId: string, Type: string) => {

    const ExportService =  Type === 'Protocol' ? ExportProtocolConsumptionWrapper : ExportConsumptionByPractitionerWrapper;

    const blob = await ExportService(authToken, filters, entityId);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Consumos_Protocolo_${new Date().toLocaleDateString()}_${new Date().toLocaleTimeString()}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
};

interface ExportToExcelLinkProps {
    Filters : IConsumptionsFilters;
    entityId: string;
    Type: string; // 'Practitioner' | 'Protocol'
}

export const ExportToExcelLink: React.FC<ExportToExcelLinkProps> = ({Filters, entityId, Type}) => {
    const token: string | undefined = useSelector((state: AppState) => state?.oidc?.user?.access_token);
    const authToken: string = token ?? '';
    
    return (
        <Button appearance='secondary' icon={<Table24Regular />}
            onClick={ ()=> { handleDownload(authToken, Filters, entityId, Type) } }
        >
            Exportar a Excel&nbsp;
        </Button>
    );
}